<template>
  <div class="driver-info new"
       :class="{'over-flow-hidden': overflowHidden}">

    <ucar-title toApp="/">注册信息</ucar-title>
    <ucar-section class="info-city" style="margin-top:45px;">
      <div class="row">
        <label>服务城市</label>
        <ucar-val :name="vuexCurrentCity.cityName"
                  :disabled="forbidenChooseServiceCity"
                  @click="showServiceCityChoose"></ucar-val>
      </div>
    </ucar-section>
    <div class="photo-info">
      <div class="photo-group-title">身份证</div>
      <div class="photo-group">
        <ucar-upload-img v-bind="photoBaseData.idCard"
                         v-model="photoInfo.idCardImgFaceUrl"
                         @uploadFinish="autoInputIdCard"
                         :error="photoError.idCardNo"></ucar-upload-img>
        <ucar-upload-img v-bind="photoBaseData.idCardBack"
                         v-model="photoInfo.idCardImgbackUrl"
                         @uploadFinish="autoInputIdCardBack"
                         :error="photoError.idCardBack"></ucar-upload-img>
      </div>
      <div class="photo-group-title">驾驶证</div>
      <div class="photo-group">
        <ucar-upload-img v-bind="photoBaseData.license"
                         v-model="photoInfo.driverLicenseImgUrl"
                         @uploadFinish="autoInputLicense"
                         :error="photoError.license"></ucar-upload-img>
        <ucar-upload-img v-bind="photoBaseData.secondLicense"
                         v-model="photoInfo.driverLicenseCopyImgUrl"
                         @uploadFinish="autoInputAmendant"
                         :error="photoError.secondLicense"></ucar-upload-img>
      </div>
      <div class="photo-group-title" v-if="vuexCurrentCity.noCrimeCertFlag">无犯罪记录证明</div>
      <div class="photo-group">
        <ucar-upload-img v-bind="photoBaseData.noCrimeCert" v-if="vuexCurrentCity.noCrimeCertFlag"
                         v-model="photoInfo.noCrimeCertImgUrl"
                         @uploadFinish="autoInputAmendant"
                         :error="photoError.noCrimeCert"></ucar-upload-img>
      </div>
    </div>
    <ucar-section>
      <div class="row row-info readOnlyDiv">
        <label>姓名</label>
        <dynamic-textarea placeholder="请输入"
                          :only-zh="true"
                          v-model="info.name"
                          ref="inp"
                          :maxlength="20"
                          :handleInput="changeName"
                          disabled
        ></dynamic-textarea>
      </div>
      <div class="row row-info readOnlyDiv">
        <label>身份证号</label>
        <number-x-keyboard-temp v-model="info.idCardNo" :maxlength="20" placeholder="请输入" disabled/>
      </div>
      <template v-if="vuexCurrentCity.id === '1' || vuexCurrentCity.cityId === '1'">
        <div class="row row-info">
          <label>户口所在地</label>
          <dynamic-textarea placeholder="请输入"
                            v-model="registeredResidence"
                            :maxlength="150"
          >
          </dynamic-textarea>
        </div>
        <div class="row row-info">
          <label>现住址</label>
          <dynamic-textarea placeholder="请输入"
                            v-model="currentAddress"
                            :maxlength="150"
          >
          </dynamic-textarea>
        </div>
      </template>
    </ucar-section>
    <ucar-section class="info-city" v-if="vuexCurrentCity.id == 227 || vuexCurrentCity.cityId == 227 || vuexCurrentCity.id == 1 || vuexCurrentCity.cityId == 1">
      <div class="row">
        <label>政治面貌</label>
        <ucar-val :name="political.politicalName"
                  @click="showServicePoliticalChoose"></ucar-val>
      </div>
    </ucar-section>
    <ucar-section>
    </ucar-section>
    <!-- <p class="driver-info-auth" v-if="enableSubmit">点击提交即表示同意<span @click="goAuthorizeProtocol">《个人征信查询授权书》</span></p> -->
    <div class="footer">
      <button type="button"
              class="btn-submit app-btn-submit"
              :class="{'app-btn-submit-enable': enableSubmit || redirectEnable}"
              @click="submit">
        提交
      </button>
    </div>
    <error-dialog v-if="showErrorDialog"
                  @close="closeErrorDialog"
                  :groups="rejectErrors"></error-dialog>
      <transition name="fade"
                mode="out-in">
      <political-choose v-if="showPoliticalChoose"
                   @change="selectPolitical"
                   :list="politicalOptions"
                   :value="{value: political.politicalStatus, name: political.politicalName}"></political-choose>
    </transition>
    <!-- <protocol-dialog v-if="showProtocolDialog"
                     @agree="signNew"
                     @close="showProtocolDialog = false"></protocol-dialog> -->
    <transition name="fade"
                mode="out-in">
                <city-choose v-if="showCityChoose"
                   @change="selectCity"
                   :list="cityOptions"
                   :value="vuexCurrentCity"></city-choose>
    </transition>
  </div>
</template>

<script>
import ucarStorage from '../../utils/storage'
import ErrorDialog from '../../components/error-dialog'
// import ProtocolDialog from '../../components/protocol-dialog'
import DynamicTextarea from '../../components/dynamic-textarea'
import CityChoose from '../../components/city-choose'
import PoliticalChoose from '../../components/political-choose'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { PhotoBaseData, resetIdCard, resetIdCardBack, resetDriverLicense, checkFailText } from '../../utils/constants'
import { transformCities, copyTargetProperty, compareTargetProperty } from '../../utils/transform'
import { getNewRecruitProgress, appDriverInfo, getRecruitSources, submitNewDriverInfo, readIdCard, readDriverLicense, getServiceCities, gaeaQuery } from '../../api'
import NumberXKeyboardTemp from "../../components/number-x-keyboard-temp"
import { popView } from "../../utils/jsBridge/jsBridge.js";
export default {
  components: {
    ErrorDialog,
    // ProtocolDialog,
    DynamicTextarea,
    NumberXKeyboardTemp,
    CityChoose,
    PoliticalChoose
  },
  data () {
    return {
      realCityId: '',
      expires: '',
      enlistId: '',
      redirectEnable: false,
      mode: 'normal',
      needLogout: true,
      rejectedCount: 0,
      showCityChoose: false,
      showErrorDialog: false,
      showPoliticalChoose: false,
      showProtocolDialog: false,
      forbidenChooseServiceCity: false, // 是否可以更改服务城市，如果当前申请单进入过人工审核状态则无法再次修改服务城市
      rejectErrors: [],
      politicalOptions: [
        {name: '群众', value: 1},
        {name: '共青团员', value: 2},
        {name: '中共党员', value: 3},
        {name: '中共预备党员', value: 4},
        {name: '民主党派成员', value: 5},
      ],
      // 身份证OCR缓存对象
      idCardOcrInfo: {
        ...resetIdCard,
        ...resetIdCardBack
      },
      // 驾驶证OCR缓存对象
      driverLicenseOcrInfo: {
        ...resetDriverLicense
      },
      info: {
        name: '',
        idCardNo: '',
        gender: '',
        idCardOcr: 1, // 后台需要，身份证OCR识别出的信息直接提交则为1，修改过则为0
        driverLicenseOcr: 1, // 后台需要，驾驶证OCR识别出的信息直接提交则为1，修改过则为0
        birthday: '',
        address: '',
        nation: '',
        issuingAuthority: '',
        validTo: '',
        validFrom: '',
        driverLicenseNo: '',
        driverLicenseName: '',
        driverLicenseAddress: '',
        driverLicenseBirthday: '',
        driverLicenseIssueDate: '', // 驾驶证初次申领时间
        driverLicenseClass: '', // 驾驶证准驾车型
        driverLicenseValidFrom: '', // 驾驶证有效期起始时间
        driverLicenseValidTo: '', // 驾驶证有效期截止时间
        houseHoldCity: {}, // 户籍城市
        onLineDriverLicenseNo: '', // 网约车驾驶员资格证号
        driverLicenseFileNo: '', // 驾驶证档案编号
        sourceId: '', // 招募来源Id
      },
      political: {
        politicalStatus: 1,
        politicalName: '群众'
      },
      registeredResidence:'',// 户口所在地
      currentAddress:'',// 现住址
      photoInfo: {
        idCardImgFaceUrl: '',
        idCardImgbackUrl: '',
        driverLicenseImgUrl: '',
        driverLicenseCopyImgUrl: '',
        onLineDriverLicenseUrl: '',
        nucleicAcidDetectionImg: '', // 核酸校验证明图片
        noCrimeCertImgUrl: '',
      },
      photoError: {
        idCardNo: '',
        idCardBack: '',
        license: '',
        // secondLicense: '',
        // networkLicense: '',
        acidDetection: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        driverLicenseTypes: [
          {
            name: 'C2',
            value: 7
          },
          {
            name: 'C1',
            value: 6
          },
          {
            name: 'B2',
            value: 5
          },
          {
            name: 'B1',
            value: 4
          },
          {
            name: 'A3',
            value: 3
          },
          {
            name: 'A2',
            value: 2
          },
          {
            name: 'A1',
            value: 1
          },
          // {
          //   name: 'C3',
          //   value: 8
          // },
          // {
          //   name: 'C4',
          //   value: 9
          // },
          // {
          //   name: 'C5',
          //   value: 10
          // },
          // {
          //   name: 'D',
          //   value: 11
          // },
          // {
          //   name: 'E',
          //   value: 12
          // },
          // {
          //   name: 'F',
          //   value: 13
          // },
          // {
          //   name: 'M',
          //   value: 14
          // },
          // {
          //   name: 'N',
          //   value: 15
          // },
          // {
          //   name: 'p',
          //   value: 16
          // },
        ],
        houseHoldCityList: [],
        tempHouseHoldCityList: [],
        serviceCityList: [],
        channelOptions: []
      },
      overflowHidden: false,
      // 识别结果 区域 姓名输入框聚焦
      infoNameInpOnFoucs: false,
    }
  },
  computed: {
    cityOptions () {
      return this.baseData.houseHoldCityList
    },
    readIdentifyComplete () {
      return this.info.idCardNo && this.info.name
    },
    enableSubmit () {
      let errorInfo =
        // valid.notEmpty(this.photoInfo.idCardImgFaceUrl, '身份证正面') ||
        // valid.notEmpty(this.photoInfo.driverLicenseCopyImgUrl, '驾驶证副本') ||
        // (this.vuexCurrentCity.noCrimeCertFlag ? valid.notEmpty(this.photoInfo.noCrimeCertImgUrl, '无犯罪记录证明') : '')
        // valid.notEmpty(this.photoInfo.idCardImgbackUrl, '身份证国徽面') ||
        // valid.notEmpty(this.photoInfo.driverLicenseImgUrl, '驾驶证正本') ||
        valid.notEmpty(this.info.name, '真实姓名') ||
        valid.notEmpty(this.info.idCardNo, '身份证号')
      if(this.vuexCurrentCity.id === '1' || this.vuexCurrentCity.cityId === '1'){
        errorInfo = valid.notEmpty(this.registeredResidence, '户口所在地') ||
          valid.notEmpty(this.currentAddress, '现住址') || errorInfo;
      }
      return errorInfo === ''
    },
    ocrComplete(){
      return this.info.name || this.info.idCardNo
    }
  },
  watch: {
  },
  methods: {
    // 增加缓存
    changeName(val){
      if(val){
        ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info), this.expires)
      }
      console.log("ucarStorage.getStorage('idCard')",ucarStorage.getStorage('idCard'))
    },
    reLayout (val) {
      this.overflowHidden = val
      if (!this.overflowHidden) {
        setTimeout(() => {
          document.documentElement.scroll(0, 2000)
          document.body.scroll(0, 2000)
        })
      }
    },
    async getNewRecruitProgressFunc(){
      const res = await getNewRecruitProgress({enlistId: this.enlistId})
      console.log('res?',res)
      if (res.driverInfo) {
        console.log('?')
        res.driverInfo.idCardImgbackUrl = res.driverInfo.idCardImgBackUrl
        delete res.driverInfo.idCardImgBackUrl
        copyTargetProperty(this.info, res.driverInfo)
        copyTargetProperty(this.photoInfo, res.driverInfo)
        this.setVuexDriverInfo(res.driverInfo)
      }
      // console.log('res.driverInfo',res.driverInfo)
      // console.log('this.vuexDriverInfo? ',this.vuexDriverInfo)
    },
    showServiceCityChoose () {
      if (!this.forbidenChooseServiceCity) this.showCityChoose = true
    },
    // 选择政治面貌
    showServicePoliticalChoose () {
      this.showPoliticalChoose = true
    },
    selectPolitical (val) {
      this.showPoliticalChoose = false
      if (val) {
        this.political.politicalStatus = val.value
        this.political.politicalName = val.name
      }
    },
    selectCity (val) {
      this.showCityChoose = false
      console.log('val?',val)
      if (val) this.setVuexCurrentCity(val)
      this.cityId = val.id
      this.realCityId = val.id
      if (!(val.cityId == 227 || val.cityId == 1)) {
        console.log('selectCity val.cityId 1111 ',val.cityId)
        this.political.politicalStatus = null
        this.political.politicalName = ''
      } else if (!this.political.politicalStatus) {
        console.log('selectCity val.cityId 2222 ',val.cityId)
        this.political.politicalStatus = 1
        this.political.politicalName = '群众'
      }
      this.$store.dispatch('setVuexCurrentCity', { id: val.id })
      this.info.nationAddress = ''
      this.info.currentAddress = ''
    },
    getBaseData () {
      this.$loading.show()
      preload([
        PhotoBaseData.idCard.defaultImg,
        PhotoBaseData.idCardBack.defaultImg,
        PhotoBaseData.license.defaultImg,
        // PhotoBaseData.secondLicense.defaultImg,
        PhotoBaseData.networkLicense.defaultImg,
        PhotoBaseData.acidCheckLicense.defaultImg
      ]).then(() => {
        return Promise.all([
          getRecruitSources(),
          getServiceCities()
        ])
      }).then(res => {
        this.baseData.channelOptions = res[0].recruitSourceList.map(item => {
          return {
            name: item.recruitSource,
            value: item.recruitSourceId
          }
        })
        this.baseData.tempHouseHoldCityList = res[1].serviceCityList
        this.baseData.houseHoldCityList = transformCities(
          res[1].serviceCityList
          , false)
        // 进不来
        console.log('1111111')
        const currentCity = this.baseData.houseHoldCity.find(item => item.cityId === this.cityId)
        this.setVuexCurrentCity({ ...currentCity, id: this.cityId })

        // if (this.vuexDriverInfo) {
        //   console.log('this.vuexDriverInfo',this.vuexDriverInfo)
        //   copyTargetProperty(this.info, this.vuexDriverInfo)
        //   this.ocrResultMessageAlert()
        //   copyTargetProperty(this.photoInfo, this.vuexDriverInfo)
        //   // 如果是从缓存中读取，需要对当前缓存中的信息做判断如果上次提交的OCR识别结果为完成，则需将当前缓存的提交信息反向映射为OCR身份证/驾驶证缓存信息，以便在提交时完成对比
        //   if (this.vuexDriverInfo.idCardOcr === 1) copyTargetProperty(this.idCardOcrInfo, this.info)
        //   if (this.vuexDriverInfo.driverLicenseOcr === 1) copyTargetProperty(this.driverLicenseOcrInfo, this.info)
        //   this.rejectedCount = this.vuexDriverInfo.driverRejectedCount
        //   this.forbidenChooseServiceCity = this.vuexDriverInfo.vehicleBindable === 1 // 如果次申请单可以绑定车辆，即代表次申请单进入过人工审核状态
        //   // if (this.vuexDriverInfo.serviceCityId) {

        //   // }
        // }
        this.$loading.hidden()
      })
    },
    async autoInputIdCard (val) {
      console.log('val?',val)
      this.$loading.show('正在识别图片信息')
      try {
        // this.trackEvent('司招-身份证正面上传', 'success')
        const res = await readIdCard({
          enlistId: this.enlistId,
          idCardImgFaceUrl: val
        })
        this.$loading.hidden()
        if (!res.idCardNo && !res.address) {
          this.info = {...this.info, ...resetIdCard}
          copyTargetProperty(this.idCardOcrInfo, this.info)
          this.photoError.idCardNo = '未识别到身份证正面信息，请重新上传'
          // this.trackEvent('司招-身份证正面识别失败', 'error')
          return
        }
        const body = {}
        for (const k in res) {
          if (res[k]) body[k] = res[k]
        }
        this.info = { ...this.info, ...body, gender: body.gender === '男' ? 1 : 0 }
        // shit
        const res2 = await getNewRecruitProgress({enlistId: this.enlistId})
        console.log('res2?',res2)
        if (res2.driverInfo) {
          console.log('res2',res2.driverInfo)
          this.info.name = res2.driverInfo.name
          this.info.idCardNo = res2.driverInfo.idCardNo
          console.log('this.info shit?',this.info)
        }
        // 缓存识别成功的身份证正面OCR信息
        if(ucarStorage.getStorage('idCard')&&!ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
          ucarStorage.setStorage('idCard',this.info,this.expires)
        }
        if(!ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('idCard',this.info,this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('idCard')&&ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
        }
        console.log('this.info',this.info)
        console.log('this.photoInfo',this.photoInfo)
        console.log('ucarStorage.getStorage("idcard")',ucarStorage.getStorage('idCard'))
        console.log('ucarStorage.getStorage("photoInfo")',ucarStorage.getStorage('photoInfo'))
        // 缓存识别成功的身份证正面OCR信息

        this.ocrResultMessageAlert()
        copyTargetProperty(this.idCardOcrInfo, this.info)
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.idCardNo = ''
      } catch (error) {
        // 识别失败，重置身份证个人信息面信息
        this.info = { ...this.info, ...resetIdCard }
        this.ocrResultMessageAlert()
        // 重置缓存中的身份证正面OCR信息
        copyTargetProperty(this.idCardOcrInfo, { ...resetIdCard })
        this.photoError.idCardNo = '未识别到姓名或身份证号，请重新上传'
        // this.trackEvent('司招-身份证正面识别失败', 'error')
      }
    },
    async autoInputIdCardBack (val) {
      this.$loading.show('正在识别图片信息')
      try {
        // this.trackEvent('司招-身份证反面上传', 'success')
        const res = await readIdCard({
          enlistId: this.enlistId,
          idCardImgBackUrl: val
        })
        // console.log('反面res????',res)
        this.$loading.hidden()
        if (!res.issuingAuthority && !res.validFrom) {
          this.info = {...this.info, ...resetIdCardBack}
          copyTargetProperty(this.idCardOcrInfo, this.info)
          this.photoError.idCardBack = '未识别到身份证反面信息，请重新上传'
          // this.trackEvent('司招-身份证反面识别失败', 'error')
          return
        }
        const body = {}
        for (const k in res) {
          if (res[k]) body[k] = res[k]
        }
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        this.info = { ...this.info, ...body }
        // shit
        const res2 = await getNewRecruitProgress({enlistId: this.enlistId})
        console.log('res2?',res2)
        if (res2.driverInfo) {
          console.log('res2',res2.driverInfo)
          this.info.name = res2.driverInfo.name
          this.info.idCardNo = res2.driverInfo.idCardNo
          console.log('this.info shit?',this.info)
        }
        // 缓存识别成功的身份证正面OCR信息
        if(ucarStorage.getStorage('idCard')&&!ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
          ucarStorage.setStorage('idCard',this.info,this.expires)
        }
        if(!ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('idCard',this.info,this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('idCard')&&ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
        }
        console.log('this.info',this.info)
        console.log('this.photoInfo',this.photoInfo)
        console.log('ucarStorage.getStorage("idcard")',ucarStorage.getStorage('idCard'))
        console.log('ucarStorage.getStorage("photoInfo")',ucarStorage.getStorage('photoInfo'))
        this.ocrResultMessageAlert()
        // 缓存识别成功的身份证国徽面OCR信息
        copyTargetProperty(this.idCardOcrInfo, this.info)
        // 去除OCR识别错误提示
        this.photoError.idCardBack = ''
      } catch (err) {
        // 识别失败，重置身份证国徽面信息
        this.info = { ...this.info, ...resetIdCardBack }
        this.ocrResultMessageAlert()
        // 重置缓存中的身份证国徽面OCR信息
        copyTargetProperty(this.idCardOcrInfo, { ...resetIdCardBack })
        this.ocrResultMessageAlert()
        this.photoError.idCardBack = '未识别到身份证国徽面信息，请重新上传'
        // this.trackEvent('司招-身份证反面识别失败', 'error')
      }
    },
    async autoInputLicense (val) {
      this.$loading.show('正在识别图片信息')
      try {
        // this.trackEvent('司招-驾照正面上传', 'success')
        const res = await readDriverLicense({
          enlistId: this.enlistId,
          drivingLicenseImgUrl: val
        })
        this.$loading.hidden()
        this.info = { ...this.info, ...res }
        // shit
        const res2 = await getNewRecruitProgress({enlistId: this.enlistId})
        console.log('res2?',res2)
        if (res2.driverInfo) {
          console.log('res2',res2.driverInfo)
          this.info.name = res2.driverInfo.name
          this.info.idCardNo = res2.driverInfo.idCardNo
          console.log('this.info shit?',this.info)
        }
        this.ocrResultMessageAlert()
        // 缓存识别成功的驾驶证OCR信息
        copyTargetProperty(this.driverLicenseOcrInfo, this.info)
        // 缓存识别成功的身份证正面OCR信息
        if(ucarStorage.getStorage('idCard')&&!ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
          ucarStorage.setStorage('idCard',this.info,this.expires)
        }
        if(!ucarStorage.getStorage('photoInfo')&&!ucarStorage.getStorage('idCard')){
          ucarStorage.setStorage('idCard',this.info,this.expires)
          ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires)
        }
        if(ucarStorage.getStorage('idCard')&&ucarStorage.getStorage('photoInfo')){
          ucarStorage.setStorage('idCard',Object.assign(ucarStorage.getStorage('idCard'),this.info),this.expires)
          ucarStorage.setStorage('photoInfo',Object.assign(ucarStorage.getStorage('photoInfo'),this.photoInfo),this.expires)
        }
        console.log('this.info',this.info)
        console.log('this.photoInfo',this.photoInfo)
        console.log('ucarStorage.getStorage("idcard")',ucarStorage.getStorage('idCard'))
        console.log('ucarStorage.getStorage("photoInfo")',ucarStorage.getStorage('photoInfo'))
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.license = ''
      } catch (error) {
        // 识别失败，重置驾驶证信息
        this.info = { ...this.info, ...resetDriverLicense }
        this.ocrResultMessageAlert()
        // 重置缓存中的驾驶证OCR信息
        copyTargetProperty(this.driverLicenseOcrInfo, { ...resetDriverLicense })
        this.photoError.license = '未识别到驾驶证正面信息，请重新上传'
        // this.trackEvent('司招-驾照正面识别失败', 'error')
      }
    },
    autoInputAmendant (val) {
      ucarStorage.setStorage('photoInfo',this.photoInfo,this.expires);
    },
    arrange () {
      this.enlistId = this.$route.query.enlistId
      this.cityId =this.$route.query.cityId
      if(ucarStorage.getStorage('idCard')){
        console.log('有idcard缓存')
        console.log("ucarStorage.getStorage('idCard')",ucarStorage.getStorage('idCard'))
        copyTargetProperty(this.info, ucarStorage.getStorage('idCard'))
        console.log('info?',this.info)
      }
      if(ucarStorage.getStorage('photoInfo')){
        console.log('有图片缓存')
        console.log("ucarStorage.getStorage('photoInfo')",ucarStorage.getStorage('photoInfo'))
        copyTargetProperty(this.photoInfo, ucarStorage.getStorage('photoInfo'))
        console.log('photoInfo?',this.photoInfo)
      }
      console.log('this.info',this.info)
      console.log('this.photoInfo',this.photoInfo)
      console.log('this.vuexDriverInfo',this.vuexDriverInfo)
      // cao
      const res = appDriverInfo({enlistId:this.enlistId})
      console.log('res?',res)
      if (res.status===3) {
        const res = getNewRecruitProgress({enlistId: this.enlistId})
        console.log('res?',res)
        if (res.driverInfo) {
          console.log('?')
          res.driverInfo.idCardImgbackUrl = res.driverInfo.idCardImgBackUrl
          delete res.driverInfo.idCardImgBackUrl
          copyTargetProperty(this.info, res.driverInfo)
          copyTargetProperty(this.photoInfo, res.driverInfo)
          this.setVuexDriverInfo(res.driverInfo)
        }
        console.log('this.cityId?',this.cityId)
        const body = {
        // 由于原司机信息缓存对象中含有驳回次数以及是否进入过人工审核字段，所以对象中的这些原有字段需要保留
        ...this.info,
        ...this.photoInfo,
        ...this.political,
        ...res.driverInfo,
        driverLicenseNo: this.info.driverLicenseNo,
        enlistId: this.enlistId,
        serviceCityId: this.cityId,
        mobile: this.vuexPersonMobile,
        // houseHoldCity: this.info.houseHoldCity.name
        }
        if(this.realCityId){
          console.log('????????')
          body.serviceCityId = this.realCityId
        }
        // 如果身份证相关信息与缓存中的身份证OCR信息不符则证明用户手动修改过身份证相关信息
        body.idCardOcr = compareTargetProperty(this.idCardOcrInfo, this.info) ? 1 : 0
        // 如果驾驶证相关信息与缓存中的驾驶证OCR信息不符则证明用户手动修改过驾驶证相关信息
        body.driverLicenseOcr = compareTargetProperty(this.driverLicenseOcrInfo, this.info) ? 1 : 0
        console.log('body?',body)
        // 缓存当前待提交的信息
        this.setVuexDriverInfo(body)
        console.log('body???',body)
        // console.log('this.setVuexDriverInfo(body)',this.vuexDriverInfo)
        return body
      }
      console.log('status!==6')
      const body = {
        // 由于原司机信息缓存对象中含有驳回次数以及是否进入过人工审核字段，所以对象中的这些原有字段需要保留
        ...this.info,
        ...this.photoInfo,
        ...this.political,
        // ...this.vuexDriverInfo,
        driverLicenseNo: this.info.driverLicenseNo,
        enlistId: this.enlistId,
        serviceCityId: this.cityId,
        mobile: this.vuexPersonMobile,
        registeredResidence: this.registeredResidence,
        currentAddress: this.currentAddress
        // houseHoldCity: this.info.houseHoldCity.name
      }
      if(this.realCityId){
        console.log('??')
        body.serviceCityId = this.realCityId
      }
      // 如果身份证相关信息与缓存中的身份证OCR信息不符则证明用户手动修改过身份证相关信息
      body.idCardOcr = compareTargetProperty(this.idCardOcrInfo, this.info) ? 1 : 0
      // 如果驾驶证相关信息与缓存中的驾驶证OCR信息不符则证明用户手动修改过驾驶证相关信息
      body.driverLicenseOcr = compareTargetProperty(this.driverLicenseOcrInfo, this.info) ? 1 : 0
      console.log('body?',body)
      // 缓存当前待提交的信息
      // this.setVuexDriverInfo(body)
      console.log('body???',body)
      // console.log('this.setVuexDriverInfo(body)',this.vuexDriverInfo)
      return body
    },
    async submit () {
      try {
        // 从身份证里获取性别 出生年月
        this.info.gender = this.info.idCardNo.substring(16,17) % 2
        let birth = this.info.idCardNo.substring(6,14)
        this.info.birthday = birth.substring(0,4) + '-' + birth.substring(4,6) + '-' + birth.substring(6,8)
        const body = this.arrange()
        body.registeredResidence = this.registeredResidence
        body.currentAddress = this.currentAddress
        // await validateNewDriverInfo(body)
        console.log('提交信息???????',body)
        // 提交司机信息
        const submitRes = await submitNewDriverInfo(body)
        // console.log('await submitNewDriverInfo(body)',submitRes)
        // console.log('submitRes.msg',submitRes.msg)
        if (submitRes.checkDriverResult !== 0) {
          const offLine = submitRes.checkDriverResult === -2
          this.$alert({
            type: 'confirm',
            dsc: `该身份证号${offLine ? checkFailText.offLine : checkFailText.settledBySubmit}`,
            okText: offLine ? '我知道了' : '我知道了，下载App',
            center: true,
            callback: () => {
              if (!offLine) {
                location.assign('https://m.10101111.com/ptdapp/d')
              }
            }
          })
          return
        }
        if (submitRes.checkResult === 1) {
        //   this.showProtocolDialog = true
          popView()
          return
        }
        // 处理驳回错误信息
        if (submitRes.checkResult === 2) {
          this.rejectedCount = submitRes.rejectedCount
          if (submitRes.idCardCheckList.length > 0) {
            const group = {
              title: '身份证',
              type: 'list',
              list: []
            }
            const list = submitRes.idCardCheckList
            list.forEach(item => {
              group.list.push(item)
            })
            this.rejectErrors.push(group)
          }
          this.showErrorDialog = true
          return
        }
        if (submitRes.checkResult === 3) {
          this.changeStatusToReviewInfo()
          if(submitRes.refuseReason.length!==0){
            this.setVuexCrimeRejectReason(submitRes.refuseReason)
            // console.log('this.vuexCrimeRejectReason???',this.vuexCrimeRejectReason)
          }
          this.$router.push(`/new-progress-info?id=${this.vuexRecruitId}`)
        }
        // 身份证号已注册
        if (submitRes.checkResult === 6) {
          this.$alert({
            type: 'confirm',
            dsc: `${submitRes.refuseReason}`,
            okText: '我知道了',
            center: true,
            // callback: () => {
            //   if (!offLine) {
            //     location.assign('https://m.10101111.com/ptdapp/d')
            //   }
            // }
          })
          return
        }
        // 当前身份证号已成为神州正式司机
        if (submitRes.checkResult === 7) {
          this.$alert({
            type: 'confirm',
            dsc: `${submitRes.refuseReason}`,
            okText: '我知道了',
            center: true,
            // callback: () => {
            //   if (!offLine) {
            //     location.assign('https://m.10101111.com/ptdapp/d')
            //   }
            // }
          })
          return
        }
      } catch (error) {
        // 报错的时候更新一下城市配置
        // this.$store.dispatch('setVuexCurrentCity', { id: this.cityId })
        console.warn(error)
      }
    },
    closeErrorDialog () {
      this.showErrorDialog = false
      this.rejectErrors = []
    },
    goAuthorizeProtocol () {
      this.arrange()
      this.$router.push('/authorize-protocol')
    },
    changeOcrResult () {
      this.infoNameInpOnFoucs = true
      this.$nextTick(() => {
        this.$refs['inp'].$refs["textarea"].focus()
      })
    },
    ocrResultMessageAlert(){
      // 判断识别结果是否有误
      let resultMessageArr = []
      let flag = true
      if(this.info.name !== this.info.driverLicenseName && this.info.name && this.info.driverLicenseName){
        // 姓名不一致
        resultMessageArr.push(`驾驶证姓名与身份证不一致`)
        flag = false
      }

      if(this.info.driverLicenseNo !== this.info.idCardNo && this.info.driverLicenseNo && this.info.idCardNo){
        // 证件号不一致
        resultMessageArr.push(`驾驶证号与身份证号不一致`)
        flag = false
      }
      if(!flag){
        resultMessageArr.push('请确认证件照片正确无误，若识别信息不正确请修改。')
        this.$alert({
          type:'confirm',
          showCancel:false,
          okText:'我知道了',
          content:'图片识别结果',
          list:[...resultMessageArr]
        })
      }

    },
    async getInfo () {
      const res = await appDriverInfo({enlistId:this.enlistId})
      console.log('getInfo res',res)
      this.registeredResidence = res.registeredResidence
      this.currentAddress = res.currentAddress
       if(this.vuexCurrentCity.cityId == 227 || this.vuexCurrentCity.id == 227 || this.vuexCurrentCity.cityId == 1 || this.vuexCurrentCity.id == 1) {
          if(res.politicalStatus){
            console.log("0000000",'00000')
             // 直接设置为群众，避免依赖politicalOptions
             this.political.politicalStatus = res.politicalStatus
              this.political.politicalName = this.politicalOptions.filter(item => item.value == this.political.politicalStatus)[0].name
          }   
           console.log("111111",'11111')   
        }   
      if(res.status===3){
        console.log('?进来了吗')
          this.$alert({
              type: 'confirm',
              dsc: `${res.reason}`,
              okText: '我知道了',
              center: true,
          }) 
          this.getNewRecruitProgressFunc()
          // this.info.name = res.name
          // this.info.idCardNo = res.idCardNumber
          // this.photoInfo.idCardImgFaceUrl = res.idCardFaceUrl
          // this.photoInfo.idCardImgbackUrl = res.idCardBackUrl
          // this.photoInfo.driverLicenseImgUrl = res.driverLicenseUrl
        }
      },

  },



  async mounted () {
    const timeRes = await gaeaQuery({key: 'enlistCache'})
    const expires = timeRes.value * 60
    this.expires = expires
    console.log('this.vuexCurrentCity',this.vuexCurrentCity)
    const enlistId = this.$route.query.enlistId
    const cityId = this.$route.query.cityId
    if (enlistId) {
      this.enlistId = enlistId
    }
    if(cityId) {
      this.cityId = cityId
      await this.$store.dispatch('setVuexCurrentCity', { id: this.cityId })
      console.log('this.vuexCurrentCity??',this.vuexCurrentCity)
    }
    console.log('this.enlistId',this.enlistId)
    console.log('this.cityId',this.cityId)
    // if (this.$route.query.redirectTo === 'new-progress-info') {
    //   this.needLogout = false
    //   this.redirectEnable = true
    // }
    this.getNewRecruitProgressFunc()
    this.getBaseData()
    this.getInfo()
    this.arrange()
    // this.sign()
  }
}
</script>

<style scoped>
>>> .ocr-info-title .ucar-section-title {
  font-weight: 550;
}

.readOnlyDiv{
  pointer-events: none;
}
</style>
